module.exports = __webpack_public_path__ + "static/media/JAGMidFi.6c105f22.png";